import React, { FC, useState } from 'react';
import { Col, Flex, Grid, Input, Popover, Row } from 'antd';
import Button from 'mixins/ui/button/button';
import { AdminContentManagement } from '../admin-content-management.type';
import SearchIcon from 'icons/search-icon.svg';
import SearchFilterIcon from 'icons/search-filter-blue.svg';
import FilterForm from './filter-form';
import { validatePrivileges } from 'mixins/helpers';
import Props = AdminContentManagement.Props;

const AdminContentManagementFilter: FC<Props> = (props: Props) => {
    const { Search } = Input;
    const [searchValue, setSearchValue] = useState<string>();
    const [isMoved, setIsMoved] = useState(false);
    const breakpoint = Grid.useBreakpoint();

    const routeToArchive = () => {
        open(props.siteUrl + props.config.archive_page_url, '_self');
    };

    const routeToCreatePage = () => {
        open(props.siteUrl + props.config.add_page_url, '_self');
    };

    const extendedSearch = (value: any) => {
        props.onSearch(value);
    };

    const clear = () => {
        props.onClear();
    };

    const content = (
        <FilterForm
            extendedSearch={extendedSearch}
            search={searchValue}
            clear={clear}
        />
    );

    const onSearch = (value: string) => {
        extendedSearch({ search: value });
    };

    const onSearchChange = (value: any) => {
        setSearchValue(value.target.value);
    };

    const onPopoverOpenChange = (open: boolean) => {
        if (open && !isMoved) {
            setIsMoved(true);

            setTimeout(() => {
                const parent = document.querySelector('.ant-input-group-wrapper');
                const child = document.querySelector('div:has(.ant-popover)');

                parent.appendChild(child);
            }, 0);
        }
    };

    return (
        <div className="admin-content-management__filter">
            <Row
                gutter={[15, 10]}
                justify="space-between"
            >
                <Col
                    xs={24}
                    xl={15}
                >
                    <Search
                        placeholder="Поиск..."
                        allowClear
                        enterButton="Искать"
                        size="large"
                        prefix={<SearchIcon />}
                        suffix={
                            !breakpoint.xs && (
                                <Popover
                                    content={content}
                                    trigger="click"
                                    placement="bottom"
                                    arrow={false}
                                    onOpenChange={onPopoverOpenChange}
                                >
                                    <a className="d-flex align-items-center gap-2 suffix">
                                        <SearchFilterIcon /> Расширенный поиск
                                    </a>
                                </Popover>
                            )
                        }
                        onSearch={onSearch}
                        onChange={onSearchChange}
                    />

                    {breakpoint.xs && (
                        <Flex
                            justify={'end'}
                            style={{
                                paddingTop: 16,
                                paddingBottom: 16,
                            }}
                        >
                            <Popover
                                content={content}
                                trigger="click"
                                placement="bottom"
                                arrow={false}
                                onOpenChange={onPopoverOpenChange}
                            >
                                <a className="d-flex align-items-center gap-2 suffix">
                                    <SearchFilterIcon /> Расширенный поиск
                                </a>
                            </Popover>
                        </Flex>
                    )}
                </Col>
                <Col
                    xs={24}
                    xl={9}
                >
                    <Row gutter={[15, 15]}>
                        <Col>
                            {validatePrivileges(
                                props.roles,
                                props.privileges,
                                'PRIV_MATERIAL_ADD'
                            ) && (
                                <Button
                                    className="filter-btn"
                                    type="primary"
                                    color="gold"
                                    uppercase={false}
                                    onClick={routeToCreatePage}
                                >
                                    Добавить материал
                                </Button>
                            )}
                        </Col>
                        <Col>
                            {validatePrivileges(
                                props.roles,
                                props.privileges,
                                'PRIV_PAGE_ARCHIVE_RESTORE'
                            ) && (
                                <Button
                                    className="filter-btn"
                                    type="primary"
                                    color="gold"
                                    uppercase={false}
                                    onClick={routeToArchive}
                                >
                                    Корзина
                                </Button>
                            )}
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default AdminContentManagementFilter;
